export default "__VITE_ASSET__382ae7e7__"